import React from 'react'
import styled from 'styled-components'

import mq from '../../utils/mediaQuery'
import { Col, Row } from '../Layout/FlexGrid'

const AvatarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const InfoWrapper = styled.div`
  width: 100%;
  ${mq.mobile} {
    text-align: center;
  }
`

const PartyInfo = React.memo(({ avatar, title, children, className }) => {
  return (
    <Row gutter={[16, 16]} className={className}>
      <Col
        xs={24}
        md={4}
        css={`
          ${mq.mobile} {
            display: none;
          }
        `}
      />
      <Col xs={24} md={20}>
        {title}
      </Col>
      <Col
        xs={24}
        md={4}
        css={`
          ${mq.mobile} {
            order: -1;
          }
        `}
      >
        <AvatarWrapper>{avatar}</AvatarWrapper>
      </Col>
      <Col xs={24} md={20}>
        <InfoWrapper>{children}</InfoWrapper>
      </Col>
    </Row>
  )
})

export default PartyInfo
